export default __webpack_public_path__ + "static/media/Truck.49f3d66c.svg";